<script>
import SessionBoxComponent from '../features/SessionBoxComponent';

export default {
  name: 'SessionBoxView',
  mixins: [SessionBoxComponent],
};
</script>

<template>
  <div v-loading.fullscreen.lock="isLogoutLoading" class="session-box-container">
    <el-dropdown trigger="click" @command="onChangeMenuOptions">
      <div class="session-trigger">
        <el-avatar :size="38" :src="profileImageUrl || undefined" class="session-avatar">
          <span class="session-avatar-initials">{{ userInitials }}</span>
        </el-avatar>
        <div class="session-info hidden-xs-only" v-if="session && session.user">
          <span class="session-name">{{ session.user.userName }}</span>
          <span class="session-role">{{ session.role ? session.role.name : '' }}</span>
        </div>
        <i class="uil uil-angle-down session-arrow"></i>
      </div>
      <template #dropdown>
        <el-dropdown-menu class="session-dropdown-menu">
          <div class="session-dropdown-header" v-if="session && session.user">
            <div class="dropdown-header-name">{{ session.user.userName }}</div>
            <div class="dropdown-header-email">{{ session.user.email }}</div>
          </div>
          <el-dropdown-item command="logout" @click="onLogout">
            <i class="uil uil-signout mr-2"></i> Cerrar Sesión
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<style scoped>
.session-box-container {
  display: flex;
  align-items: center;
}
.session-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 8px;
  transition: background 0.2s ease;
}
.session-trigger:hover {
  background: rgba(0, 0, 0, 0.04);
}
.session-avatar {
  border: 2px solid #e0e0e0;
  background-color: #2c3e50;
  color: #ffffff;
}
.session-avatar-initials {
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.02em;
  user-select: none;
}
.session-info {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.session-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.2;
}
.session-role {
  font-size: 0.72rem;
  color: #7f8c8d;
}
.session-arrow {
  font-size: 1rem;
  color: #7f8c8d;
}
.session-dropdown-menu {
  min-width: 200px;
  padding: 6px 0;
}
.session-dropdown-header {
  padding: 8px 16px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 4px;
}
.dropdown-header-name {
  font-size: 0.88rem;
  font-weight: 600;
  color: #2c3e50;
}
.dropdown-header-email {
  font-size: 0.75rem;
  color: #7f8c8d;
  word-break: break-all;
}
.mr-2 {
  margin-right: 8px;
}
</style>
